import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as JiraLogo } from 'assets/svgs/jira-logo.svg';
import { PanelHeaderTitle } from 'components/atoms/collapse';
import { IconShell } from 'components/atoms/icon-shell';

export const JiraIssuesTitle: FC = () => (
  <PanelHeaderTitle
    icon={<IconShell icon={<JiraLogo />} />}
    title={<FormattedMessage id="settings.integrations.jira.title" />}
  />
);
